import script from "./confirmWithdrawModal.vue?vue&type=script&setup=true&lang=js"
export * from "./confirmWithdrawModal.vue?vue&type=script&setup=true&lang=js"

import "./confirmWithdrawModal.vue?vue&type=style&index=0&id=0433afe3&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0433afe3"]])

export default __exports__